import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { fromHex, stripPrefix } from "@findeth/abi";
import EIP1193Provider from "./eip-1193";
import EthersProvider from "./ethers";
import HttpProvider from "./http";
import Web3Provider from "./web3";
var providers = [EIP1193Provider, EthersProvider, HttpProvider, Web3Provider];
export var getProvider = function getProvider(a) {
  var b = providers.find(function (b) {
    return b.isProvider(a);
  });
  if (!b) throw new Error("Invalid provider type");
  return b;
};
/**
* Send a call with the data, using the specified provider. If the provider is not a valid provider type (e.g. not a
* Ethers.js provider, URL or Web3 provider), this will throw an error.
*
* @param {ProviderLike} providerLike
* @param {string} contractAddress
* @param {string} data
* @return {Promise<Uint8Array>}
*/

export var call = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a, b, c) {
    var _d, d;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return send(a, "eth_call", [{
              to: b,
              data: c
            }, "latest"]);

          case 3:
            _d = _context.sent;

            if (!stripPrefix(_d).startsWith("08c379a")) {
              _context.next = 6;
              break;
            }

            throw new Error("Call reverted");

          case 6:
            return _context.abrupt("return", fromHex(_d));

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            throw new Error("Failed to get data from contract: ".concat(null !== (d = _context.t0.stack) && void 0 !== d ? d : _context.t0.toString()));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function call(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var send = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(a, b, c) {
    var d;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            d = getProvider(a);
            return _context2.abrupt("return", d.send(a, b, c));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function send(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();